<template>
	<section>
		<div class="modal fade" id="modalDetailDevice" tabindex="-1" role="dialog" aria-labelledby="modalDetailKontakTitle" aria-hidden="true">
		    <div class="modal-dialog modal-dialog-centered" role="document">
		        <div class="modal-content mx-auto">                           
		            <div class="modal-body">                
		                <p class="f-14 f-m-12"><b>Detail Kontak</b>   
		                <button type="button" class="close float-right" data-dismiss="modal" aria-label="Close">
		                    <span aria-hidden="true">&times;</span>
		                </button></p>
		                <hr>
		                <p class="title-colee f-12">Nama</p>
		                <p class="f-14 f-m-12">{{ !detail?'':detail.name }}</p>
		                <hr>
		                <p class="title-colee f-12">Nomor handphone</p>
		                <p class="f-14 f-m-12">{{ !detail?'':detail.phone_number }}</p>
		                <hr>
		                <p class="title-colee f-12">Alamat</p>
		                <p class="f-14 f-m-12">{{ !detail?'':detail.address }}</p>
		                <hr>
		                <p class="title-colee f-12">Kordinat lokasi</p>
		                <GmapMap
								class		= "maps mb-2"
								style		= "height: 100px"
								:center		= map.center
								:options	= mapOptions 
								:zoom		= map.zoom	
						>
							<gmap-marker
									v-for="(item, index) in markers"
									:key="index"
									:position="item"
							/>
						</GmapMap>
						<p class="f-14"><b>{{ map.address }} </b></p>
		            </div>
		        </div>
		    </div>
		</div>
	</section>
</template>

<script>
import Vue from "vue"
export default {
	name: 'ModalDetail',
	props: ['detail'],
	data(){
		return {
			mapOptions	: {
				streetViewControl	: false,
				fullscreenControl	: false,
				mapTypeControl		: false,
			},
			markers		: [],
			map			: {
				address	: '',
				place	: '',
				center	: { 
					lat	: -2.2145852388265177, 
					lng	: 117.104081069627 
				},
				zoom	: 4
			}
		}
	},
	methods:{
		addMarker(data) {
		    let _ = this
			if(data.lat != null && data.lng != null){
				var latLng = {
					lat: parseFloat(data.lat),
					lng: parseFloat(data.lng)
				}

				_.markers 		= [latLng]
				_.map.center 	= latLng
				_.map.zoom 		= 18

				Vue.$geocoder.send(latLng, response => {
					_.map.address = response.results[0].formatted_address
				})
			}	
		},
	},
	watch: {
		'detail': function(){
			this.addMarker(this.detail)
		}
	}	
}
</script>